import { Spinner } from '@chakra-ui/react'
import { StyledLoading } from '@nextui-org/react'
import React from 'react'

const Loading = () => {
  return (
    <div className='absolute bg-gray-700/50 h-full w-full top-0 left-0 right-0 bottom-0'>
        <div className='flex justify-center gap-2 items-center pt-80'>
            <Spinner color='white'/>
            <h1 className='text-white font-bold'>Ачааллаж байна</h1>
        </div>
    </div>
  )
}

export default Loading
